module.exports = __webpack_public_path__ + "static/media/p8_img6.58359357.svg";